import { useSelector } from 'react-redux';
import { selectAuthStatus } from '../../features/auth/store/authSlice';
import { hasAuth0Config } from '../config/env';

export function useApiReady() {
  const authStatus = useSelector(selectAuthStatus);
  const authEnabled = hasAuth0Config();

  return !authEnabled || authStatus === 'succeeded';
}
